<template>
  <sweet-modal ref="modal" icon="warning" hide-close-button class="vld-parent">
    <loading :active="savingTemplate" :is-full-page="false" />

    <p>
      <StrongI18n
        :keypath="'modals.name_exists'"
        :values="{propName: conflictingName}"
      />
    </p>

    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" id="update-designer" @click="overwrite">
        {{ $t('modals.overwrite_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'ConflictTemplateModal',
  components: {
    SweetModal,
    Loading,
    StrongI18n
  },
  computed: {
    ...mapState({
      savingTemplate: state => state.savingTemplate,
      conflict: state => state.conflict,
      templateName: state => state.templateName,
      success: state => state.success,
      duplicate: state => state.duplicateTemplate,
      selectedTemplate: state => state.duplicateTemplateData
    }),
    conflictingName() {
      return this.conflict?.name || '';
    }
  },
  methods: {
    ...mapActions(['duplicateTemplate', 'updateTemplate']),
    overwrite() {
      if (this.duplicate) {
        this.duplicateTemplate({
          originalTemplate: this.selectedTemplate.id,
          overwrite: true
        });
      } else {
        const payload = {
          templateName: this.templateName,
          templateId: this.conflict.id
        };
        this.updateTemplate(payload);
      }
    },
    close() {
      this.$refs.modal.close();
    }
  },
  watch: {
    success(newValue) {
      if (newValue === true) {
        this.$refs.modal.close();
      }
    },
    conflict(newValue) {
      if (newValue.status === undefined || !newValue.status) {
        this.$refs.modal.close();
      } else if (
        newValue.kind !== 'rename' &&
        newValue.kind !== 'rowCategory'
      ) {
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
